import { render, staticRenderFns } from "./InventoryView.vue?vue&type=template&id=a6c548c4"
import script from "./InventoryView.vue?vue&type=script&lang=js"
export * from "./InventoryView.vue?vue&type=script&lang=js"
import style0 from "./InventoryView.vue?vue&type=style&index=0&id=a6c548c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports